const asRecord = (value: unknown): Record<string, unknown> | undefined =>
  typeof value === 'object' && value !== null ? (value as Record<string, unknown>) : undefined

const asString = (value: unknown): string => (typeof value === 'string' ? value.trim() : '')

export const applySavedSessionFlag = (sessions: readonly unknown[], sessionId: string, saved: boolean): unknown[] =>
  sessions.map(session => {
    const record = asRecord(session)
    if (!record || asString(record.id) !== sessionId) return session
    return { ...record, saved }
  })
